<template>
  <div>
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 3}" />
    </a-spin>
    <!-- 表单 -->
    <div v-show="!loading">
      <s-table
        style="display: table;max-width: 1400px;"
        ref="table"
        rowKey="id"
        showQuickJumper
        :columns="columns"
        :data="loadData"
      >
        <template slot="operationType" slot-scope="text,record">
          <span v-if="record.operationType ==='A'"><a-tag color="#198754">Add</a-tag></span>
          <span v-else-if="record.operationType ==='B'"><a-tag color="#0D6EFD">Modify</a-tag></span>
          <span v-else-if="record.operationType ==='C'"><a-tag color="#DC3545">Delete</a-tag></span>
          <span v-else-if="record.operationType ==='M'"><a-tag color="#f50">Merge</a-tag></span>
          <span v-else><a-tag color="#faad14">Recovery</a-tag></span>
        </template>
        <template slot="changeFrom" slot-scope="text,record">
          <span v-if="record.changeFrom ==='A'">CDB</span>
          <span v-else>OBS</span>
        </template>
        <template slot="updateInfo" slot-scope="updateInfo, row">
          <div v-if="updateInfo">
            <div v-for="(group, groupIndex) in row.updateGroupList" :key="row.id + '-' + groupIndex">
              <div style="font-weight: 500;">{{ group.name }}</div>
              <div v-for="(item, itemIndex) in group.itemList" :key="row.id + '-' + groupIndex + '-' + itemIndex">
                <span style="color: #000000D9;">{{ item.name }}: </span><span>{{ item.before }}</span> <a-icon type="arrow-right" style="margin: 0 10px;" /><span>{{ item.after }}</span>
              </div>
            </div>
          </div>
        </template>
        <template slot="obsOperatorName" slot-scope="text,record">
          <span v-if="record.changeFrom ==='A'">{{ record.changeBy && record.changeBy.userName }}</span>
          <span v-else>{{ record.obsOperatorName }}</span>
        </template>
        <!-- <template slot="beforeChangeData" slot-scope="data, row">
          <div v-if="data">
            <span class="dataText">
              <span>Last:</span>
              <span>{{ data.lastName }}</span>
            </span>
            <span class="dataText">
              <span>First:</span>
              <span>{{ data.firstName }}</span>
            </span>
            <span class="dataText">
              <span>Middle:</span>
              <span>{{ data.middleName}}</span>
            </span>
            <span class="dataText">
              <span>Gender:</span>
              <span>{{ data.gender }}</span>
              </span>
            <span class="dataText">
              <span>DOB:</span>
              <span v-if="data.birthday">{{ data.birthday[1] + '/' + data.birthday[2] + '/' + data.birthday[0] }}</span>
            </span>
            <div v-if="data.contactList && data.contactList.length > 0">
              <span v-for="(contact, contactIndex) in data.contactList" :key="row + '-' + contactIndex">
                <span v-if="contact.contactType === '1'" class="dataText">
                  <span>Email:</span>
                  <span> {{ contact.email }}</span>
                </span>
                <span v-else class="dataText">
                  <span>Phone:</span>
                  <span v-if="contact.phoneCountryCode && contact.phoneCountryCode.length > 0">{{ contact.phoneCountryCode }}</span>
                  <span>{{ contact.phoneNumber }}</span>
                  <span v-if="contact.phoneExt && contact.phoneExt.length > 0">{{ contact.phoneExt }}</span>
                </span>
              </span>
            </div>
          </div>
        </template> -->
      </s-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import OperationlogApi from '@/api/api-cdb-customer-operationlog'
import { Title, RealationShip } from '@/utils/helper/standard-code-utils'
import { Meals, Special } from '@/utils/helper/dict-cdb-utils'
import StateApi from '@/api/basicdata/api-state'

export default {
  name: 'CdbCustomerLogs',
  components: {
    STable
  },
   props: {
    customerId: {
      type: String,
      required: true
    },
    languageList: {
      type: Array,
      default: () => []
    },
    backgroundList: {
      type: Array,
      default: () => []
    },
    ethnicitiesList: {
      type: Array,
      default: () => []
    },
    countryList: {
      type: Array,
      default: () => []
    },
    realationShipList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      loading: true,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { customerId: this.customerId },
      titleList: Title.dict,
      mealsList: null,
      specialList: null,
      // 表头
      columns: [
        {
          title: 'Date/Time',
          dataIndex: 'changeTime',
          align:'center',
          customRender: (value, record) => this.DateTimeUtil().localString(value !== null ? value : record.changeTime, 'MM/DD/YYYY hh:mm:ss')
        },
        {
          title: 'Action Type',
          dataIndex: 'operationType',
          scopedSlots: { customRender: 'operationType' }
        },
        {
          title: 'Detail',
          dataIndex: 'updateInfo',
          scopedSlots: { customRender: 'updateInfo' }
        },
        {
          title: 'By',
          dataIndex: 'obsOperatorName',
          scopedSlots: { customRender: 'obsOperatorName' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return this.ensureInitData()
          .then(() => OperationlogApi.queryNew(Object.assign(parameter, this.queryParam)))
          .then(res => {
            const list = res.data.datas
            if (list && list.length > 0) {
              list.forEach(it => {
                // it.beforeChangeData = (it.beforeChangeData && it.beforeChangeData.length > 0) ? JSON.parse(it.beforeChangeData) : null
                try {
                  it.updateInfo = (it.updateInfo && it.updateInfo.length > 0) ? JSON.parse(it.updateInfo) : null
                } catch (e) {
                  // 单条日志格式异常时不影响整个列表
                  it.updateInfo = null
                }
                if (it.updateInfo) {
                  it.updateGroupList = it.updateInfo.groupList
                  if (it.updateGroupList && it.updateGroupList.length > 0) {
                    for (let i=0; i<it.updateGroupList.length; i++) {
                      const itemList = it.updateGroupList[i].itemList
                      if (itemList && itemList.length > 0) {
                        for (let j=0; j<itemList.length; j++) {
                          const item = itemList[j]
                          // 处理title
                          if (item.name === 'Title') {
                            item.before = this.getDictName(this.titleList, item.before)
                            item.after = this.getDictName(this.titleList, item.after)
                          }
                          // 处理RM Pref
                          if (item.name === 'RM Pref') {
                            item.before = item.before === '1' ? 'TWN' : (item.before === '2' ? 'DBL' : 'N/A')
                            item.after = item.after === '1' ? 'TWN' : (item.after === '2' ? 'DBL' : 'N/A')
                          }
                          // Primary Language
                          if (item.name === 'Primary Language') {
                            item.before = this.getLanguageName(item.before)
                            item.after = this.getLanguageName(item.after)
                          }
                          // Other Language
                          if (item.name === 'Other languages') {
                            item.before = this.getLanguageNames(item.before, this.languageList)
                            item.after = this.getLanguageNames(item.after, this.languageList)
                          }
                          // Origin
                          if (item.name === 'Origin') {
                            item.before = this.getDictName(this.backgroundList, item.before)
                            item.after = this.getDictName(this.backgroundList, item.after)
                          }
                          // Ethnicities
                          if (item.name === 'Ethnicities') {
                            item.before = this.getDictName(this.ethnicitiesList, item.before)
                            item.after = this.getDictName(this.ethnicitiesList, item.after)
                          }
                          // Relationship
                          if (item.name === 'Relationship') {
                            const list = this.realationShipList || []
                            
                            item.before = (item.before && item.before !== '') ? (
                              list.filter(tmp => tmp.id == item.before)[0]?.rsName || 'N/A'
                            ) : 'N/A'
                            
                            item.after = (item.after && item.after !== '') ? (
                              list.filter(tmp => tmp.id == item.after)[0]?.rsName || 'N/A'
                            ) : 'N/A'
                          }
                          // Country
                          if (item.name === 'Country') {
                            item.before = this.getCountryName(item.before)
                            item.after = this.getCountryName(item.after)
                          }
                          // State/Province
                          if (item.name === 'State/Province') {
                            item.before = this.getStateName(item.before)
                            item.after = this.getStateName(item.after)
                          }
                          // Meals Restrictions
                          if (item.name === 'Meals Restrictions') {
                            item.before = this.getDictNamesByCodes(item.before, this.mealsList)
                            item.after = this.getDictNamesByCodes(item.after, this.mealsList)
                          }
                          // Special Requests
                          if (item.name === 'Special Requests') {
                            item.before = this.getDictNamesByCodes(item.before, this.specialList)
                            item.after = this.getDictNamesByCodes(item.after, this.specialList)
                          }

                          // 空显示成N/A
                          item.before = (item.before == null || item.before === '') ? 'N/A' : item.before
                          item.after = (item.after == null || item.after === '') ? 'N/A' : item.after
                        }
                      }
                    }
                  }
                }
              })
            }
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      contactList: RealationShip.dict,
      stateList: [],
      initDataPromise: null
    }
  },
  mounted () {
    this.ensureInitData()
  },
  methods: {
    // 字典只加载一次，loadData 在渲染日志前等待其完成
    ensureInitData () {
      if (!this.initDataPromise) {
        this.initDataPromise = this.loadInitData().catch(err => {
          this.initDataPromise = null
          throw err
        })
      }
      return this.initDataPromise
    },
    async loadInitData () {
      this.loading = true
      try {
        const [mealsList, specialList, stateListRes] = await Promise.all([
          Meals.getDict(),
          Special.getDict(),
          StateApi.list()
        ])
        this.mealsList = mealsList
        this.specialList = specialList
        this.stateList = stateListRes.data
      } finally {
        // 任一字典加载失败时也要结束 loading，避免骨架屏一直转
        this.loading = false
      }
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    },
    // 按字典 code 获取英文名
    getDictName (list, code) {
      if (code == null || code === '' || !list || list.length === 0) {
        return 'N/A'
      }
      const found = list.find(tmp => tmp.code == code)
      return found && found.enName ? found.enName : 'N/A'
    },
    // 获取语言名称，如 English (ENG)
    getLanguageName (code) {
      if (code == null || code === '' || !this.languageList || this.languageList.length === 0) {
        return 'N/A'
      }
      const lang = this.languageList.find(tmp => tmp.code == code)
      return lang ? `${lang.enName} (${lang.lgCode})` : 'N/A'
    },
    // 获取国家名称
    getCountryName (countryId) {
      if (countryId == null || countryId === '' || !this.countryList || this.countryList.length === 0) {
        return 'N/A'
      }
      const country = this.countryList.find(tmp => tmp.id == countryId)
      return country && country.nameEnUs ? country.nameEnUs : 'N/A'
    },
    // 获取州名称
    getStateName (stateId) {
      if (stateId == null || stateId === '' || !this.stateList || this.stateList.length === 0) {
        return 'N/A'
      }
      const state = this.stateList.find(tmp => tmp.id == stateId)
      return state && state.nameEnUs ? state.nameEnUs : 'N/A'
    },
    // 将逗号分隔的字典 code 转成英文名，如 '1,2' => 'Vegetarian,Vegan'
    getDictNamesByCodes (codes, list) {
      if (!codes || codes === '' || !list || list.length === 0) {
        return ''
      }
      return codes.split(',')
        .map(code => {
          const found = code ? list.find(tmp => tmp.code == code) : null
          return found ? found.enName : ''
        })
        .filter(name => name)
        .join(',')
    },
    getLanguageNames (codes, languageList) {
      if (!codes || codes === '') return 'N/A'
      const codeArray = codes.split(',').filter(code => code)
      const names = codeArray.map(code => {
        const lang = languageList.find(langItem => langItem.code === code)
        return lang ? `${lang.enName} (${lang.lgCode})` : 'N/A'
      })
      return names.join(', ')
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-tag {
  font-weight: 500;
}
::v-deep .ant-table-tbody > tr > td:not(:nth-last-child(2)) {
  white-space: nowrap;
}
.plate-title:before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 15px;
  margin-right: 6px;
  background: #1890ff;
  position: relative;
  top: 3px;
}
.dataText {
  margin-right:12px;
}
.dataText :first-child {
  margin-right:5px;
  font-weight:600;
}
</style>
